<template>
    <section class="chart-container" >
        <div class=" ml20 mr20" >

<!--            <div class="font28 pt20 pb20">首页</div>-->
            <el-col :span="24">
                <el-col :span="4">
                    <div class="jb01 br10 p15 mb15 white_text yinying position_r" style="overflow:hidden;">
                        <div style="background:#fff;width:160px;height:160px; left:-20px;top:-110px; opacity:0.2" class="br50 position_a"></div>
                        <div class="position_r">
                        <div class="row flex-between">
                            <div class="row flex-start "><div class="white_text font16 fontwb row flex-start"><img src="../../static/img/tiancheng03_hq.svg"  style="width:30px;height:30px;"/>本月总净重{{recoData.WeighingUnit}}</div></div>
                            <div class="font12 fontwb">比上个月{{recoData.mainData3.thisMonthJz>recoData.mainData3.lastMonthJz?'+':'-'}} {{recoData.mainData3.bfb}}%</div>
                        </div>
                        <div class="font30 fontwb">{{recoData.mainData3.thisMonthJz||00}}</div>
                        </div>
                    </div>
                    <div class="white_bg br10 p15 mb15 yinying">
                        <div class="row flex-between">
                            <div class="row flex-start "><div class="br5 mr15 yellow_bg2" style="width:4px;height:16px;"></div><div class="yellow_text2 font16 fontwb">今日总净重</div></div>
                            <div class="font20 fontwb">{{recoData.mainData3.todayJz||00}}</div>
                        </div>
                    </div>
                    <div class="white_bg br10 p15 yinying">
                        <div class="row flex-between">
                            <div class="row flex-start "><div class="br5 mr15 purple_bg" style="width:4px;height:16px;"></div><div class="purple_text font16 fontwb">前一天总净重</div></div>
                            <div class="font20 fontwb">{{recoData.mainData3.yesterdayJz||00}}</div>
                        </div>
                    </div>
                    <div class="white_bg yinying font18 mt15 mb15 br10 pt15 pb15 pl20" style="color:#A6A6A6">温馨提示：数据会有一定的延时</div>
                </el-col>
                <el-col :span="20">
                    <div class="white_bg yinying br10 ml20 pt20 pl20 ">
                        <div id="myChart2" style="width:100%;height:287px;"></div>
                    </div>
                </el-col>
            </el-col>

            <el-col :span="24">
                <div class="pt10"></div>

            </el-col>
            <el-col :span="24">
                <div class="white_bg yinying br10 pt20 pl20 ">
                    <div id="myChart4" style="width:100%;height:400px;"></div>
                </div>
            </el-col>

            <el-col :span="24"  style="display:none">
                <el-col :span="12">
            <div class="white_bg h100 br10 mb20 " style="box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);overflow:hidden;">
<!--            <el-col :span="24"  class="h100">-->
<!--                <el-col :span="4" class="h100">-->
<!--                    <div class=" font14  cursorp w100" style="background:#fff;border-right:solid 1px #eee">-->
<!--                        <div :class="active3==0?'yellow_bg':''" class="row flex-center w100 position_r h100 cursorp pt10 pb10" @click="onTab3(0)">近一年</div>-->
<!--                        <div :class="active3==1?'yellow_bg':''" class="row flex-center w100 position_r h100 cursorp pt10 pb10" @click="onTab3(1)">近一月</div>-->
<!--                        <div :class="active3==2?'yellow_bg':''" class="row flex-center w100 position_r h100 cursorp pt10 pb10" @click="onTab3(2)">近一周-->

<!--                        </div>-->
<!--                    </div>-->
<!--                </el-col>-->
<!--                <el-col :span="20" class="h100">-->

<!--                    <div class="row flex-center font18 h100" style="height:120px;">-->
<!--                        <div class="w100 column flex-centerall  h100"><div class="font14"><i class="el-icon-s-goods"></i>{{recoData.dateTypeValue.name}}</div><div class="fontwb blue_text">{{recoData.dateTypeValue.value}}{{recoData.WeighingUnit}}</div></div>-->
<!--                        <div class="w100 column flex-centerall  h100"><div  class="font14"><i class="el-icon-star-on"></i>{{recoData.dateTypeValue2.name}}</div><div class="fontwb green_text">{{recoData.dateTypeValue2.value}}{{recoData.WeighingUnit}}</div></div>-->
<!--                        <div class="w100 column flex-centerall  h100"><div  class="font14"><i class="el-icon-s-flag"></i>{{recoData.dateTypeValue3.name}}</div><div class="fontwb purple_text">{{recoData.dateTypeValue3.value}}次</div></div>-->
<!--                    </div>-->
<!--                </el-col>-->

<!--            </el-col>-->
            </div>
                    <div class="white_bg yinying br10 ml20 mt20">
                        <div id="myChart3" style="width:100%;height:400px;"></div>
                    </div>

        </el-col>
        <el-col :span="12">
            <div class="white_bg yinying br10 ml20">
            <div id="myChart" style="width:100%;height:400px;"></div>
            </div>
        </el-col>
        </el-col>


        </div>
    </section>
</template>

<script>
    import axios from "axios";
    import XLSX from 'xlsx'
    import echarts from 'echarts'
    export default {
        data() {
            return {
            active:1,
          active3:0,
	      week:'',// 本周周几
	      date_show:'', //本日日期
	      user: JSON.parse(window.localStorage.getItem('user')),

                myChart: {},
                xData: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], //横坐标
                yData: [3000, 2800, 900, 1000, 800, 700, 1400, 1300, 900, 1000, 800, 600], //y数据


                recoData:{
                    WeighingUnit:'',
                    recParams:{
                        api:'weighingrecord',
                        methods:'get',
                        machine_code:'',
                        page_size:10,
                        page:1,
                        order:'desc',
                        data:'',
                        conditions:{Valid:1},
                        keywords:'',
                        createtime_begin_at:'',
                        createtime_end_at:'',

                    },

                    dateType:'year',//年月日筛选
                    mainData:{
                        dateList:[],
                    },
                    mainData2:{
                        dateList:[],
                    },
                    mainData3:'',
                    dateTypeValue:{},//毛重
                    dateTypeValue2:{},//净重
                    dateTypeValue3:{},//车次
                    }
            }
        },

        methods: {

//记录查询页 s

get_weighing_statistics(){//获取称重统计
let self=this
let params={period:'30days',machine_code:self.optionValue}
let params2={period:'12months',machine_code:self.optionValue}
let params3={machine_code:self.optionValue}
self.$axios.post(self.baseApiUrl+'account4/admin/weighing_record_statistics/chartdata',params).then(function (res) {
 if(res.data.code==1){
 self.recoData.mainData=res.data.data
         self.$axios.post(self.baseApiUrl+'account4/admin/weighing_record_statistics/chartdata',params2).then(function (res) {
         if(res.data.code==1){
         self.recoData.mainData2=res.data.data
         self.drawLine()

            self.$axios.get(self.baseApiUrl+'account4/admin/weighing_record_statistics/peek',{params:params3}).then(function (res3) {
                if(res.data.code==1){
                    self.recoData.mainData3=res3.data.data
                    let a4=(res3.data.data.thisMonthJz-res3.data.data.lastMonthJz)/res3.data.data.lastMonthJz*100
                    self.recoData.mainData3.bfb=a4.toFixed(2);
                }
             })

                let recParams=self.recoData.recParams
                recParams.machine_code=self.optionValue
                self.$axios.get(self.baseApiUrl+'uploadata/getjsonkey',{"params": recParams}).then(function (res) {
                        if(res.data.code==1){
                             let resList=res.data.data.value.Details[0].Settings//表头

                             resList = resList.map(t => {
                                if(t.Key=='WeighingUnit'){
                                self.recoData.WeighingUnit=t.Value
                                }
                                return t;
                            })
                    }
                })


         }
        })

 }
})
},









getoptionList(){
let self=this
 let machparam={type:2}
        self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam).then(function (res) {
            console.log("get_machine_code_list-res")
            console.log(res.data.data)
            let resdata=res.data.data
            let optionList = resdata.map(t => {
            return {
               value: t.machine_code,
                label:t.remark
               }
             })
            console.log("optionList")
            console.log(optionList)
            self.optionList=optionList

                let machparam1={type:1}
                self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam1).then(function (res) {
                    console.log("get_machine_code_list-res2")
                    console.log(res.data.data)
                    let resdata2=res.data.data
                    let optionList2 = resdata2.map(t => {
                        return {
                            value: t.machine_code,
                            label:t.remark
                           }
                     })
                    self.optionList=self.optionList.concat(optionList2)
                    //self.optionValue=self.optionList[0].value
                    self.optionValue=self.optionList[0]?self.optionList[0]:''
                    if(self.active==1){
                    //self.getRecoredList()
                    self.get_weighing_statistics()
                    }

                })

        })
        },

 drawLine () {
 let self=this
 console.log("曲线图")
  var edu = ['专科', '本科', '硕士', '博士'
        ];
        var eduS = [200, 120, 256, 250];


        var comp = ['100-200', '200-300', '300-500', '<100'
        ];
        var compS = [200, 120, 256, 250];

        var exper = ['1年经验', '2年经验', '3年经验', '4年经验', '5年经验'
        ];
        var experS = [250, 200, 180, 190, 200];

        var colors = ['#96d668', '#01babc', '#1a98f8', '#7049f0'];

        let titles = ["学历与岗位数量", "公司规模与岗位数量", "工作经验与岗位数量"];

        let option = {
          color: colors ,
       legend: {
        orient: 'vertical',
        bottom:'15%',
        right:"10%",
        itemGap: 20,
        textStyle:{color:"#aaa"},
        data:[
            '学历', '城市', '经验'
        ]
    },
          title: [{
            text: titles[1],
            left: "70%",
            textStyle: {
              color: "#fff",
              fontSize: "14"
            }
          }, {
            left: "25%",
            text: titles[0],
            textStyle: {
              color: "#fff",
              fontSize: "14"
            }
          },{
            left: "25%",
            top: "52%",
            text: titles[2],
            textStyle: {
              color: "#fff",
              fontSize: "14"
            }
          },
          {
            left: "62%",
            top: "55%",
            text: "工作经验与岗位数量",
            subtext:"根据招聘信息分析所得",
            textStyle: {
              color: "#fff",
              fontSize: "24",
              align:"center",
            }
          }
          ],
          grid: [{
            x: '8%',
            y: '8%',
            width: '40%',
            height: "40%",
            containLabel: true
          },
          {
            x2: '8%',
            y: '8%',
            width: '40%',
            height: "40%",
            containLabel: true
          },
          {
            x: '8%',
            y2: '0',
            width: '40%',
            height: "40%",
            bottom: "2%",
            containLabel: true
          },
          ],
          tooltip: {
            formatter: '{b}:<br/> {c}'
          },
          xAxis: [
            {
              gridIndex: 0,
              type: 'category',
              boundaryGap: true, //坐标轴两边留白
              data: edu,
              axisLabel: { //坐标轴刻度标签的相关设置。
                interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
                margin: 15,
                textStyle: {
                  color: '#ddd',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                }
              },
              axisTick: {
                show: false,
              },
              axisLine: { //坐标轴轴线相关设置
                lineStyle: {
                  color: '#ddd',
                  opacity: 0.2
                }
              },
              splitLine: {
                show: false,
              }
            },
            {
              gridIndex: 1,
              type: 'category',
              boundaryGap: true, //坐标轴两边留白
              data: comp,
              axisLabel: { //坐标轴刻度标签的相关设置。
                interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
                margin: 15,
                textStyle: {
                  color: '#ddd',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                }
              },
              axisTick: { //坐标轴刻度相关设置。
                show: false,
              },
              axisLine: { //坐标轴轴线相关设置
                lineStyle: {
                  color: '#ddd',
                  opacity: 0.2
                }
              },
              splitLine: { //坐标轴在 grid 区域中的分隔线。
                show: false,
              }
            },
            {
              gridIndex: 2,
              type: 'category',
              boundaryGap: true, //坐标轴两边留白
              data: exper,
              axisLabel: { //坐标轴刻度标签的相关设置。
                interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
                margin: 15,
                textStyle: {
                  color: '#ddd',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                }
              },
              axisTick: { //坐标轴刻度相关设置。
                show: false,
              },
              axisLine: { //坐标轴轴线相关设置
                lineStyle: {
                  color: '#ddd',
                  opacity: 0.2
                }
              },
              splitLine: { //坐标轴在 grid 区域中的分隔线。
                show: false,
              }
            }
          ],
          yAxis: [{
            gridIndex: 0,
            name:"/ 岗位数量",
            nameTextStyle:{color:"#a8aab0"},
            axisLabel: {
              textStyle: {
                color: '#a8aab0',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12,
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#fff'],
                opacity: 0.06
              }
            }
          },
          {
            gridIndex: 1,
            name:"/ 岗位数量",
            nameTextStyle:{color:"#a8aab0"},
            axisLabel: {
              textStyle: {
                color: '#a8aab0',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12,
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#fff'],
                opacity: 0.06
              }
            }
          },
          {
            gridIndex: 2,
            name:"/ 岗位数量",
            nameTextStyle:{color:"#a8aab0"},
            axisLabel: {
              textStyle: {
                color: '#a8aab0',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12,
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#fff'],
                opacity: 0.06
              }
            }
          }
          ],
          series: [
            {
              type: 'line',
              name:'学历',
              xAxisIndex: 0,
              yAxisIndex: 0,
             symbolSize: 8,
        symbol: 'circle',
              data: eduS
            },
            {
              type: 'line',
              name:'城市',
              xAxisIndex: 1,
              yAxisIndex: 1,
              symbolSize: 8,
        symbol: 'circle',
              data: compS
            },
            {
              type: 'line',
              name:'经验',
              xAxisIndex: 2,
              yAxisIndex: 2,
             symbolSize: 8,
        symbol: 'circle',
              data: experS
            }
          ]
        }

      this.myChart = echarts.init(document.getElementById("myChart"));
      this.myChart.setOption(option);







var myChart2 = echarts.init(document.getElementById('myChart2'));
// 指定图表的配置项和数据
    	var option2 = {
	    title: {
	        text: '最近12个月趋势'
	    },
	    tooltip: {
	        trigger: 'axis'
	    },
	    legend: {
	        data: ['总毛重','总净重']
	    },

	    grid: {
            show:false,
            left: "5%",
            top: "25%",
            right: "5%",
            bottom: "19%",
        },
	    xAxis: [{
	    splitLine:{
	     lineStyle: {
          type: 'dashed'    //设置网格线类型 dotted：虚线   solid:实线
        },
　　　　show:false
　　},
    axisTick: {
        show: false, // 坐标轴刻度线隐藏
    },
    axisLabel: { color: '#1C2F45' },
       axisLine: {
       lineStyle: {
           color: '#DADADA', // 坐标轴刻度颜色
       },
   },
	        type: 'category',

	        data: self.recoData.mainData2.dateList
	    }],
	    yAxis: [{
	    show:false,
	    	  splitLine: {
                show: false,
                lineStyle: {
                    color: "rgba(112,145,127,.1)",
                },
            },
            min:0,
	        type: 'value',
	        name: '总毛重',
	        position: 'right',

	    },
	    {
	    show:false,
	    splitLine:{
        　　　　show:false
        　　},
            //max:2000,
	        type: 'value',
	        name: '总净重',
	        position: 'left'
	    }],

	    series: [{
	        name: '总净重',
	        type: 'bar',
	        barWidth: 20,
	         itemStyle: {
              normal: {
               label: {
                  show: false, //开启显示数值
                  position: 'top', //数值在上方显示
                },
                   barBorderRadius: [44, 44, 0, 0],
                color: '#3F85FF',

              },
            },
	        yAxisIndex: 1,
	        stack: '总量',
	            label: {
	                normal: {
	                    show: true,
	                    position: 'top'
	                }
	            },

	        data: self.recoData.mainData2.jzList
	    },{
	        name: '总毛重',
	        type: 'line',
symbol:'none',
smooth:true,
            // symbolSize: 8,
           // symbol: 'circle',
            color: ["#9214ff"],
	        areaStyle: {
              normal: {
                //color: '#9214FF',
                 color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [
                            {
                                offset: 0,
                                color: "rgba(146,20,255,0.4)", // 0% 处的颜色
                            },
                            {
                                offset: 1,
                                color: "rgba(146,20,255,0)", // 100% 处的颜色
                            },
                        ],
                        global: false, // 缺省为 false
                    },

              },
              lineStyle: {
                width: 4, // 折线宽度
               },
            },
	        stack: '总量',
	            label: {
	                normal: {
	                    show: true,
	                    position: 'top',
	                }
	            },
	        lineStyle: {
	                normal: {
	                    width: 3,
	                    shadowColor: 'rgba(0,0,0,0.4)',
	                    shadowBlur: 10,
	                    shadowOffsetY: 10
	                }
	            },
	        data: self.recoData.mainData2.mzList
	    }]
	};

        // 使用刚指定的配置项和数据显示图表。
        myChart2.setOption(option2);









    var myChart4 = echarts.init(document.getElementById('myChart4'));
    	var option4 = {
	    title: {
	        text: '30天过磅数据'
	    },
	    color: [
          '#2777EC',
          '#2EACFF',
          '#FFA61C',
          '#2EC054',
          '#F28685',
          '#8C64D7'
        ],
       // legend: {
        //  show: true,
       //   right: '50%',
       //   itemWidth: 11,
       //   itemHeight: 11
       // },
    legend: {
      show: true,icon: "circle",
         right: '50%',
         itemWidth: 11,
          itemHeight: 11,
	    data: ['净重','毛重'],
        //x: "right",
        textStyle: {
            color: "#000"
        }
    },


        tooltip: {
          trigger: 'axis'
        },
        grid: {
        show:false,
          x: '7%',
          y: '15%',
          x2: '3%',
          y2: '15%'
        },
        xAxis: [
          {
            splitLine:{
             lineStyle: {
                type: 'dashed'    //设置网格线类型 dotted：虚线   solid:实线
             },
            　show:false
        　　},
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(151, 151, 151, 1)'
              }
            },
            axisLabel: {
              show: true,
              // margin: 20,
              textStyle: {
                color: '#000'
              }
            },
            axisTick: {
              show: false
            },
            // boundaryGap: true,
            data: self.recoData.mainData.dateList
          }
        ],

        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(151, 151, 151, 1)'
              }
            },
            axisLabel: {
              show: true,
              // margin: 20,
              textStyle: {
                color: '#000'
              }
            },
            axisTick: {
              show: true,
              color: 'rgba(151, 151, 151, 1)'
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(226, 232, 236, 1)',
                type: 'dashed'
              }
            },
            splitArea: {
              show: false,
              areaStyle: {
                color: ['#fff', 'rgba(245, 246, 250, 1)']
              }
            }
          }
        ],
        series: [
          {
            name: '毛重',
            type: 'bar',
            smooth: false,
              barWidth: 10,
	         itemStyle: {
                  normal: {
                   barBorderRadius: [16, 16, 0, 0],
                    color: '#4DE3D1',
                  },
              },
            // showSymbol: false,/
            symbolSize: 8,
            zlevel: 3,
            lineStyle: {
              normal: {
                color: '#157DFF'
              }
            },
            data: self.recoData.mainData.mzList
          },
          {
            name: '净重',
              barWidth: 10,
	         itemStyle: {
                  normal: {
                   barBorderRadius: [16, 16, 0, 0],
                color: '#3F85FF',
                  },
              },
            type: 'bar',
            smooth: false,
            // showSymbol: false,
            symbolSize: 8,
            zlevel: 3,
            lineStyle: {
              normal: {
                color: '#5FD77E'
              }
            },
            data: self.recoData.mainData.jzList
          }
        ]
	};

        // 使用刚指定的配置项和数据显示图表。
        myChart4.setOption(option4);









              var myChart3 = echarts.init(document.getElementById('myChart3'));
//TODO: 不可更改薪资范围，否则颜色
let yName = ["30K-50K", "20K-30K", "15K-20K", "10K-15K", "8K-10K", "6K-8K", "4K-6K"];
let option3 = {
    title: [{
                text: "Java",
                 right:"25%",
                textStyle: {
                  color: "#fff",
                  fontSize: "14"
                }
              },{
                 left:"25%",
                text: "Python",
                textStyle: {
                  color: "#fff",
                  fontSize: "14"
                }
              },
              {
                text: "SQL",
                 right:"25%",
                 top:"50%",
                textStyle: {
                  color: "#fff",
                  fontSize: "14"
                }
              },{
                 left:"25%",
                 top:"50%",
                text: "TOMACAT",
                textStyle: {
                  color: "#fff",
                  fontSize: "14"
                }
              }
              ],
    grid: [{
            x: '8%',
            y: '8%',
            width: '40%',
            height:"40%",
            containLabel: true
        },
        {
            x2: '8%',
            y: '8%',
            width: '40%',
            height:"40%",
            containLabel: true
        },
        {
            x: '8%',
            y2: '0',
            width: '40%',
            height:"40%",
            containLabel: true
        },
        {
            x2: '8%',
            y2: '0',
            width: '40%',
            height:"40%",
            containLabel: true
        },
    ],
    xAxis: [{
            gridIndex: 0,
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            }
        },
        {
            gridIndex: 1,
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            }
        },
        {
            gridIndex: 2,
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            }
        },
        {
            gridIndex: 3,
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            }
        },
    ],
    yAxis: [{
        gridIndex: 0,
        interval: 0,
        data: yName,
        axisTick: {
            show: false
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: "#ddd"
            }
        },
        splitLine: {
            show: false
        },
        axisLine: {
            show: false
        },
    }, {
        gridIndex: 1,
        interval: 0,
        data: yName,
        axisTick: {
            show: false
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: "#ddd"
            }
        },
        splitLine: {
            show: false
        },
        axisLine: {
            show: false
        },
    },
    {
        gridIndex: 2,
        interval: 0,
        data: yName,
        axisTick: {
            show: false
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: "#ddd"
            }
        },
        splitLine: {
            show: false
        },
        axisLine: {
            show: false
        },
    }, {
        gridIndex: 3,
        interval: 0,
        data: yName,
        axisTick: {
            show: false
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: "#ddd"
            }
        },
        splitLine: {
            show: false
        },
        axisLine: {
            show: false
        },
    }
    ],
    series: [
        {
            name: 'python',
            type: 'bar',
            xAxisIndex: 0,
            yAxisIndex: 0,
            itemStyle: {
                // normal:{color:'#4f9aff',barBorderRadius:[0,10,10,0],}
                normal: {
                    barBorderRadius: [0, 8, 8, 0],
                    borderWidth: 0,
                    borderColor: '#fff',
                    label:{
                        show:true,
                        position:'right',
                        formatter:function(v){
                          return v.value + "%";
                        },
                    },
                    color: function(params) {
                        // build a color map as your need.
                        var colorList = [
                            '#b250ff',// 最后一个
                            '#4849b5',
                            '#ffa800',
                            '#E5C37D',


                            '#7f80e1b3', '#5c6d9ab3',
                            '#837e86',
                            '#fdc86a'

                        ];

                        return colorList[params.dataIndex]
                    },
                     //shadowBlur: 20,
                    //shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            barGap: '0',
            barWidth:'20',
            barCategoryGap: '5%',
            data: [10, 32, 28, 18, 2, 5, 5, ]
        },
        {
            name: 'Java',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            itemStyle: {
                // normal:{color:'#4f9aff',barBorderRadius:[0,10,10,0],}
                normal: {
                    barBorderRadius: [0, 8, 8, 0],
                    borderWidth: 0,
                    borderColor: '#fff',
                    label:{
                        show:true,
                        position:'right',
                        formatter:function(v){
                          return v.value + "%";
                        },
                    },
                    color: function(params) {
                        // build a color map as your need.
                        var colorList = [
                            '#b250ff',// 最后一个
                            '#4849b5',
                            '#ffa800',
                            '#E5C37D',


                            '#7f80e1b3', '#5c6d9ab3',
                            '#837e86',
                            '#fdc86a'
                        ];

                        return colorList[params.dataIndex]
                    },
                    //shadowBlur: 20,
                    //shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            barGap: '0',
            barWidth:'20',
            barCategoryGap: '5%',
            data: [10, 42, 8, 28, 2, 5, 5, ]
        },
        {
            name: 'SQL',
            type: 'bar',
            xAxisIndex: 2,
            yAxisIndex: 2,
            itemStyle: {
                // normal:{color:'#4f9aff',barBorderRadius:[0,10,10,0],}
                normal: {
                    barBorderRadius: [0, 8, 8, 0],
                    borderWidth: 0,
                    borderColor: '#fff',
                    label:{
                        show:true,
                        position:'right',
                        formatter:function(v){
                          return v.value + "%";
                        },
                    },
                    color: function(params) {
                        // build a color map as your need.
                        var colorList = [
                            '#b250ff',// 最后一个
                            '#4849b5',
                            '#ffa800',
                            '#E5C37D',


                            '#7f80e1b3', '#5c6d9ab3',
                            '#837e86',
                            '#fdc86a'

                        ];

                        return colorList[params.dataIndex]
                    },
                     //shadowBlur: 20,
                    //shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            barGap: '0',
            barWidth:'20',
            barCategoryGap: '5%',
            data: [10, 32, 28, 18, 2, 5, 5, ]
        },
        {
            name: 'TOMACAT',
            type: 'bar',
            xAxisIndex: 3,
            yAxisIndex: 3,
            itemStyle: {
                // normal:{color:'#4f9aff',barBorderRadius:[0,10,10,0],}
                normal: {
                    barBorderRadius: [0, 8, 8, 0],
                    borderWidth: 0,
                    borderColor: '#fff',
                    label:{
                        show:true,
                        position:'right',
                        formatter:function(v){
                          return v.value + "%";
                        },
                    },
                    color: function(params) {
                        // build a color map as your need.
                        var colorList = [
                            '#b250ff',// 最后一个
                            '#4849b5',
                            '#ffa800',
                            '#E5C37D',


                            '#7f80e1b3', '#5c6d9ab3',
                            '#837e86',
                            '#fdc86a'
                        ];

                        return colorList[params.dataIndex]
                    },
                    //shadowBlur: 20,
                    //shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            barGap: '0',
            barWidth:'20',
            barCategoryGap: '5%',
            data: [10, 42, 8, 28, 2, 5, 5, ]
        }

    ]
};

        // 使用刚指定的配置项和数据显示图表。
        myChart3.setOption(option3);


      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        //this.myChart.resize();
        this.myChart2.resize();
        //this.myChart3.resize();
        this.myChart4.resize();
      });


    },













//记录查询页 e


// 获取当前系统日期
getdataTime(){
  let wk = new Date().getDay()
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth() + 1;
  let dd = new Date().getDate();
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  this.week = weeks[wk]
  this.date_show =  mm + "月" + dd + "日"

},
// 获取当前系统的时间
getnewTime(){
  let hh = new Date().getHours();
  let mf =
    new Date().getMinutes() < 10
      ? "0" + new Date().getMinutes()
      : new Date().getMinutes();
  let ss =
    new Date().getSeconds() < 10
      ? "0" + new Date().getSeconds()
      : new Date().getSeconds();
  this.time_show = hh + ":" + mf + ":" + ss;
},









        },

        mounted: function () {
            this.getoptionList()
        }
    }
</script>

<style lang="scss">
.select_bottom{
  .el-select-dropdown__item.selected{
    color:#000;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background:#fef03e;
    color:#666;
  }
}
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #fef03e;
    }
  .el-select .el-input .el-input__inner:hover{
    border-color: #fef03e;
    }
  .el-pagination.is-background .el-pager li:not(.disabled).active{background-color: #fef03e;color:#333}

  .el-pagination.is-background .el-pager li:not(.disabled):hover{background-color: #fef03e;color:#333}
</style>



// WEBPACK FOOTER //
// MainIndex.vue?5603d638